import { GlobalStyles } from "./styles/GlobalStyles";
import { useEffect } from "react";
import { BrowserRouter, useLocation, useNavigate } from "react-router-dom";
import { MotionConfig } from "framer-motion";
import Header from "./components/header/Header";
import SideLines from "./components/sideLines/SideLines";
import Intro from "./views/intro/Intro";
import About from "./views/about/About";
import Experience from "./views/experience/Experience";
import Projects from "./views/projects/Projects";
import Contact from "./views/contact/Contact";
import Footer from "./components/footer/Footer";
import OtherProjects from "./views/otherProjects/OtherProjects";
const ScrollToHash = () => {
  const { hash } = useLocation();
  useEffect(() => {
    if (!hash) return undefined;
    const frame = window.requestAnimationFrame(() => {
      const rawTargetId = hash.slice(1);
      let targetId = rawTargetId;
      try {
        targetId = decodeURIComponent(rawTargetId);
      } catch {
        targetId = rawTargetId;
      }
      const target = document.getElementById(targetId);
      const reduceMotion =
        typeof window.matchMedia === "function" &&
        window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      target?.scrollIntoView?.({
        behavior: reduceMotion ? "auto" : "smooth",
        block: "start",
      });
    });
    return () => window.cancelAnimationFrame(frame);
  }, [hash]);
  return null;
};
const CanonicalPath = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (pathname !== "/") navigate("/", { replace: true });
  }, [pathname, navigate]);

  return null;
};

const DeferredAnalytics = () => {
  useEffect(() => {
    if (window.location.hostname !== "viethoang.dev") return undefined;

    let idleHandle;
    let timeoutHandle;
    let cancelled = false;

    const loadAnalytics = () => {
      if (
        cancelled ||
        document.querySelector(
          'script[data-website-id="dc6b8945-ebb4-4aa9-b840-92f4e6902f55"]',
        )
      )
        return;

      const script = document.createElement("script");
      script.src = "https://cloud.umami.is/script.js";
      script.async = true;
      script.dataset.websiteId = "dc6b8945-ebb4-4aa9-b840-92f4e6902f55";
      script.dataset.domains = "viethoang.dev";
      document.head.appendChild(script);
    };

    const scheduleAnalytics = () => {
      if (typeof window.requestIdleCallback === "function") {
        idleHandle = window.requestIdleCallback(loadAnalytics, {
          timeout: 3000,
        });
      } else {
        timeoutHandle = window.setTimeout(loadAnalytics, 1500);
      }
    };

    if (document.readyState === "complete") {
      scheduleAnalytics();
    } else {
      window.addEventListener("load", scheduleAnalytics, { once: true });
    }

    return () => {
      cancelled = true;
      window.removeEventListener("load", scheduleAnalytics);
      if (idleHandle !== undefined) window.cancelIdleCallback(idleHandle);
      if (timeoutHandle !== undefined) window.clearTimeout(timeoutHandle);
    };
  }, []);

  return null;
};

function App({ Router = BrowserRouter, routerProps }) {
  return (
    <MotionConfig reducedMotion="user">
      <Router {...routerProps}>
        <GlobalStyles />
        <CanonicalPath />
        <ScrollToHash />
        <DeferredAnalytics />
        <a className="skip-link" href="#main-content">
          Skip to main content
        </a>
        <Header />
        <div id="page-shell">
          <SideLines />
          <main id="main-content" tabIndex="-1">
            <Intro />
            <About />
            <Experience />
            <Projects />
            <OtherProjects />
            <Contact />
          </main>
          <Footer />
        </div>
      </Router>
    </MotionConfig>
  );
}
export default App;
